/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { IUserIRoute } from "../../generated/Api";
import Loading from "../Loading";
import CreateTimeCard from "../Modal/container/EmailSettings/container/FavoriteTime/CreateTimeCard";
import TimeCard from "../Modal/container/EmailSettings/container/FavoriteTime/TimeCard";
import SortableList from "../SortableList/SortableList";
import Switch from "../Switch";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 47px;
  height: fit-content;

  @media screen and (max-width: 720px) {
    width: 100%;

    flex-direction: column;
    align-items: flex-start;
    grid-gap: 8px;
  }
`;

const Title = styled.div`
  color: #2f2f2f;
  font-weight: 600;
  margin-bottom: 5px;
`;

const AddButton = styled.div`
  color: #fb972e;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  margin-top: 15px;
`;

const CheckDescription = styled.div`
  margin-left: 5px;
  font-size: 14px;
  color: #2f2f2f;
`;

const TitleDescription = styled.div`
  color: #bebebe;
  font-size: 13px;
`;

const SubjectDescription = styled.div`
  color: #707070;
  font-size: 14px;
`;

export const FavoriteTimesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  grid-gap: 10px;
`;

interface Props {
  user: IUserIRoute;
  setUser: (u: IUserIRoute) => void;
}

export default function FavoriteTimeUserSettings(props: Props) {
  const { user, setUser } = props;
  const [add, setAdd] = useState(false);
  const [favoriteScheduleTimesArray, setFavoriteScheduleTimesArray] = useState<
    string[]
  >([]);
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    if (!user && !user.options.favoriteScheduleTimes.length) return;
    setFavoriteScheduleTimesArray(user.options.favoriteScheduleTimes);
    setFlag(!flag);
  }, [user.options.favoriteScheduleTimes]);

  async function handleUpdateFavoriteScheduleTime(
    newFavoriteTimesOrder: string[]
  ) {
    if (!newFavoriteTimesOrder.length) return;

    setFavoriteScheduleTimesArray(newFavoriteTimesOrder);

    setUser({
      ...user,
      options: {
        ...user.options,
        favoriteScheduleTimes: newFavoriteTimesOrder,
      },
    });
  }

  return (
    <FlexColumn>
      <div>
        <Title>Favorite Times</Title>
        <SubjectDescription>Enable favorite times</SubjectDescription>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          @media screen and (max-width: 720px) {
            margin: 8px 0 0;

            align-items: flex-start;
          }
        `}
      >
        <Switch
          toggled={user.options.enableFavoriteTimes}
          whenToggled={(vle) =>
            setUser({
              ...user,
              options: { ...user.options, enableFavoriteTimes: vle },
            })
          }
          css={css`
            margin-bottom: 25px;
          `}
        />

        {user.options.enableFavoriteTimes && (
          <>
            <FavoriteTimesWrapper key={`${flag}`}>
              {user.options?.favoriteScheduleTimes ? (
                <SortableList
                  items={favoriteScheduleTimesArray}
                  onDragEnd={(items: string[]) => {
                    handleUpdateFavoriteScheduleTime(items);
                  }}
                >
                  {favoriteScheduleTimesArray.map((fTime, index) => {
                    return (
                      <div
                        css={css`
                          width: 285px;
                        `}
                      >
                        <TimeCard
                          key={fTime + index}
                          id={index.toString()}
                          time={fTime}
                          edit={(date) => {
                            let newFavoriteScheduleTimes =
                              user.options.favoriteScheduleTimes.map((dd, id) =>
                                id === index ? date : dd
                              );

                            setUser({
                              ...user,
                              options: {
                                ...user.options,
                                favoriteScheduleTimes: newFavoriteScheduleTimes,
                              },
                            });
                          }}
                          delete={() => {
                            let newFavoriteScheduleTimes =
                              user.options.favoriteScheduleTimes.filter(
                                (dd, id) => id !== index
                              );

                            setUser({
                              ...user,
                              options: {
                                ...user.options,
                                favoriteScheduleTimes: newFavoriteScheduleTimes,
                              },
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </SortableList>
              ) : (
                <Loading />
              )}
            </FavoriteTimesWrapper>

            <AddButton onClick={() => setAdd(!add)}>
              {!add
                ? favoriteScheduleTimesArray.length
                  ? "+ Click to add another favorite send time"
                  : "+ Click to add your first favorite send time"
                : "Close"}
            </AddButton>

            {add && (
              <CreateTimeCard
                addTime={(date) => {
                  setUser({
                    ...user,
                    options: {
                      ...user.options,
                      favoriteScheduleTimes: [
                        ...user.options.favoriteScheduleTimes,
                        date,
                      ],
                    },
                  });
                  setAdd(false);
                }}
              />
            )}
          </>
        )}
      </div>
    </FlexColumn>
  );
}
